import { Controller } from "@hotwired/stimulus";
import MapResourceLoader from "../services/map_resource_loader.js";

export default class extends Controller {
  static targets = ["toggleText", "details", "mapboxStatus", "leafletStatus", "loadTime"];

  connect() {
    this.startTime = performance.now();
    this.updateStatus();
    
    // Update status every 2 seconds
    this.statusInterval = setInterval(() => {
      this.updateStatus();
    }, 2000);
  }

  disconnect() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
  }

  toggleDetails() {
    this.detailsTarget.classList.toggle('hidden');
    const isHidden = this.detailsTarget.classList.contains('hidden');
    this.toggleTextTarget.textContent = isHidden ? 'Show Details' : 'Hide Details';
  }

  async refreshStatus() {
    await this.updateStatus();
  }

  async updateStatus() {
    const status = MapResourceLoader.getStatus();
    
    // Update Mapbox status
    if (this.hasMapboxStatusTarget) {
      if (status.mapbox.loaded) {
        this.mapboxStatusTarget.textContent = '✅ Loaded';
        this.mapboxStatusTarget.className = 'font-mono text-green-600';
      } else if (status.mapbox.loading) {
        this.mapboxStatusTarget.textContent = '⏳ Loading...';
        this.mapboxStatusTarget.className = 'font-mono text-yellow-600';
      } else {
        this.mapboxStatusTarget.textContent = '❌ Not Loaded';
        this.mapboxStatusTarget.className = 'font-mono text-red-600';
      }
    }

    // Update Leaflet status
    if (this.hasLeafletStatusTarget) {
      if (status.leaflet.loaded) {
        this.leafletStatusTarget.textContent = '✅ Loaded';
        this.leafletStatusTarget.className = 'font-mono text-green-600';
      } else if (status.leaflet.loading) {
        this.leafletStatusTarget.textContent = '⏳ Loading...';
        this.leafletStatusTarget.className = 'font-mono text-yellow-600';
      } else {
        this.leafletStatusTarget.textContent = '❌ Not Loaded';
        this.leafletStatusTarget.className = 'font-mono text-red-600';
      }
    }

    // Update load time
    if (this.hasLoadTimeTarget && this.startTime) {
      const elapsed = performance.now() - this.startTime;
      this.loadTimeTarget.textContent = `${elapsed.toFixed(0)}ms`;
    }
  }
}
